var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
/** @jsxImportSource theme-ui */
import { TextInput } from "@bottlebooks/gatsby-design-system";
import { Field } from "formik";
import FieldLayout from "./FieldLayout";
import useFormTheme from "./useFormTheme";
/**
 *
 * @param {object} props
 * @param {string} props.name The path to the field in lodash-like dot path, such as `social.facebook` or `friends[0].firstName`.
 * @param {string | JSX.Element} props.label The localized label.
 * @param {string | JSX.Element} [props.description] The description.
 * @param {number | string} props.length The approximate length of the text.
 * @returns
 */
export default function TextField(_a) {
    var { name, label, description, length } = _a, rest = __rest(_a, ["name", "label", "description", "length"]);
    const theme = useFormTheme();
    return (_jsx(FieldLayout, { name: name, label: label, description: description, children: _jsx(Field, Object.assign({ name: name, as: TextInput, sx: Object.assign({ width: typeof length === "number" ? `${length}ch` : length }, theme === null || theme === void 0 ? void 0 : theme.input) }, rest)) }));
}
//# sourceMappingURL=TextField.js.map